export default "__VITE_ASSET__jmtPrn7$__"